// The languages ScoreLM speaks (#1063). English is the source and the
// fallback; French and Spanish load on demand. 'pseudo' is a QA locale
// (dev and staging only): English, accented and padded, so a missed string
// or a layout that can't take longer text shows at a glance.

export const LOCALES = ['en', 'fr', 'es'] as const
export type Locale = (typeof LOCALES)[number]
export type AnyLocale = Locale | 'pseudo'

export const DEFAULT_LOCALE: Locale = 'en'

/** Each language in its own words (never translated). */
export const LOCALE_NAMES: Record<Locale, string> = {
  en: 'English',
  fr: 'Français',
  es: 'Español',
}

export function isLocale(v: unknown): v is Locale {
  return typeof v === 'string' && (LOCALES as readonly string[]).includes(v)
}

/** The pseudo-locale is for QA builds only: dev, and staging (which sets the template override flag). */
export const PSEUDO_ENABLED: boolean = import.meta.env.DEV || import.meta.env.VITE_SITE_TEMPLATE_OVERRIDE === '1'

export function isAnyLocale(v: unknown): v is AnyLocale {
  return isLocale(v) || (PSEUDO_ENABLED && v === 'pseudo')
}

/** The BCP 47 tag Intl formats with. */
export function intlTag(locale: AnyLocale): string {
  return locale === 'pseudo' ? 'en-US' : locale === 'en' ? 'en-US' : locale
}
